export const OPEN_HELP_CENTER_EVENT = "OPEN_HELP_CENTER";

export interface OpenHelpCenterPayload {
  scope: string;
  itemOrders?: number[];
}

// Scopes cuyo Centro de ayuda navega menú -> subitem en lugar de mostrar
// una lista plana de items.
export const NESTED_HELP_CENTER_SCOPES = ["tab_strategies", "tab_sequences"];

export const isNestedHelpCenterScope = (scope?: string) =>
  NESTED_HELP_CENTER_SCOPES.includes(scope ?? "");

export interface NestedHelpCenterIntro {
  title: string;
  description: string;
  docsLabel?: string;
  // Ruta relativa a VITE_WEB_DOC. Sin ella no se muestra el enlace a docs.
  docsPath?: string;
}

export const NESTED_HELP_CENTER_INTRO: Record<string, NestedHelpCenterIntro> = {
  tab_strategies: {
    title: "Estrategias",
    description:
      "Crea y lanza estrategias masivas para contactar con tus contactos. Conoce más sobre",
    docsLabel: "Estrategias",
    docsPath: "/operaciones/modulo-estrategias",
  },
  // cuando exista el artículo de Secuencias en knowledge.beexcc.com.
  tab_sequences: {
    title: "Secuencias",
    description: "Diseña y automatiza flujos de comunicación para interactuar con tus contactos de manera oportuna. Conoce más sobre",
    docsLabel: "Secuencias",
    docsPath: "/flujos/modulo-secuencias",
  },
};
